import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import React from 'react'

export default class DialogForm extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <Dialog
        fullWidth
        maxWidth="md"
        open={this.props.open}
        onClose={this.props.onClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent>{this.props.children}</DialogContent>
        <DialogActions>
          {this.props.update ? (
            <Button onClick={this.props.onValidate} variant="contained" type="submit">
              Modifier
            </Button>
          ) : (
            <Button onClick={this.props.onValidate} variant="contained" type="submit">
              Ajouter
            </Button>
          )}

          <Button onClick={this.props.onClose}>Annuler</Button>
        </DialogActions>
      </Dialog>
    )
  }
}
